import frontage from './frontage';
import offers from './offers';
import restaurants from './restaurants';
import rooms from './rooms';
import general from './general';
import navigation from './navigation';
import metatags from './metatags';

const index = {
  frontage: frontage,
  offers: offers,
  restaurants: restaurants,
  rooms: rooms,
  general: general,
  navigation: navigation,
  metatags: metatags,
};

export default index;